import React, { Component } from 'react'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

import LocateControl from './LocateControl';

import L from 'leaflet';

const myCustomColour = '#00733f';

const markerHtmlStyles = `
  background-color: ${myCustomColour};
  width: 2rem;
  height: 2rem;
  display: block;
  left: -1rem;
  top: -1rem;
  position: relative;
  border-radius: 2rem 2rem 0;
  transform: rotate(45deg);
  border: 2px solid #FFFFFF`
  
  export default class Map extends Component {
    render() {
  
      const position = [47.45, 7.65]
  
      if (typeof window !== 'undefined') {

        /* 2021-09-12: had to move this here for SSR to work */
        const icon = L.divIcon({
          className: "my-custom-pin",
          iconAnchor: [0, 24],
          labelAnchor: [-6, 0],
          popupAnchor: [0, -36],
          html: `<span style="${markerHtmlStyles}" />`
        })        

        return (
  
            <MapContainer center={position} zoom={11} style={{zIndex: 0, height: '700px'}} >
              <TileLayer
              url="https://tile.osm.ch/osm-swiss-style/{z}/{x}/{y}.png"
              attribution='&amp;copy <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors'/>
              <LocateControl startDirectly/>   
<Marker icon={icon} position={[47.54806179261617, 7.547262233791886]}><Popup><a href="#allschwil">Allschwil</a></Popup></Marker>
<Marker icon={icon} position={[47.41588, 7.71664]}><Popup><a href="#arboldswil">Arboldswil</a></Popup></Marker>
<Marker icon={icon} position={[47.49259, 7.62397]}><Popup><a href="#arlesheim">Arlesheim</a></Popup></Marker>
<Marker icon={icon} position={[47.55811, 7.62981]}><Popup><a href="#birsfelden">Birsfelden</a></Popup></Marker>
<Marker icon={icon} position={[47.45273, 7.51675]}><Popup><a href="#blauen">Blauen</a></Popup></Marker>
<Marker icon={icon} position={[47.50547, 7.86461]}><Popup><a href="#buus">Buus</a></Popup></Marker>
<Marker icon={icon} position={[47.41232, 7.81268]}><Popup><a href="#diegten">Diegten</a></Popup></Marker>
<Marker icon={icon} position={[47.44249, 7.49677]}><Popup><a href="#dittingen">Dittingen</a></Popup></Marker>
<Marker icon={icon} position={[47.47977, 7.55600]}><Popup><a href="#ettingen">Ettingen</a></Popup></Marker>
<Marker icon={icon} position={[47.50192, 7.69772]}><Popup><a href="#frenkendorf">Frenkendorf</a></Popup></Marker>
<Marker icon={icon} position={[47.50839, 7.72627]}><Popup><a href="#füllinsdorf">Füllinsdorf</a></Popup></Marker>
<Marker icon={icon} position={[47.48945, 7.89221]}><Popup><a href="#hemmiken">Hemmiken</a></Popup></Marker>
<Marker icon={icon} position={[47.42505, 7.77072]}><Popup><a href="#hölstein">Hölstein</a></Popup></Marker>
<Marker icon={icon} position={[47.46434, 7.78386]}><Popup><a href="#itingen">Itingen</a></Popup></Marker>
<Marker icon={icon} position={[47.38906, 7.67611]}><Popup><a href="#lauwil">Lauwil</a></Popup></Marker>
<Marker icon={icon} position={[47.50756, 7.54103]}><Popup><a href="#oberwil">Oberwil</a></Popup></Marker>
<Marker icon={icon} position={[47.46837, 7.87309]}><Popup><a href="#ormalingen">Ormalingen</a></Popup></Marker>
<Marker icon={icon} position={[47.51725, 7.69540]}><Popup><a href="#pratteln">Pratteln</a></Popup></Marker>
<Marker icon={icon} position={[47.447972997656514, 7.765973141196305]}><Popup><a href="#ramlinsburg">Ramlinsburg</a></Popup></Marker>
<Marker icon={icon} position={[47.48549, 7.57114]}><Popup><a href="#reinach">Reinach</a></Popup></Marker>
<Marker icon={icon} position={[47.48541, 7.83986]}><Popup><a href="#rickenbach bl">Rickenbach BL</a></Popup></Marker>
<Marker icon={icon} position={[47.43170, 7.88514]}><Popup><a href="#rünenberg">Rünenberg</a></Popup></Marker>
<Marker icon={icon} position={[47.41191, 7.69601]}><Popup><a href="#seltisberg">Seltisberg</a></Popup></Marker>
<Marker icon={icon} position={[47.45718, 7.81329]}><Popup><a href="#sissach">Sissach</a></Popup></Marker>
<Marker icon={icon} position={[47.40171795560499, 7.71741575565272]}><Popup><a href="#titterten">Titterten</a></Popup></Marker>
<Marker icon={icon} position={[47.45069, 7.92098]}><Popup><a href="#wenslingen">Wenslingen</a></Popup></Marker>
<Marker icon={icon} position={[47.40928, 7.91572]}><Popup><a href="#zeglingen">Zeglingen</a></Popup></Marker>
            </MapContainer>
  
        )
      }
      return null
    }
  }
